export default __webpack_public_path__ + "static/media/330_dummy2016-baeckerei01-mobile-de.5f0c6ead.png";